import { updateItemInCollection } from "directus/src/operations";

export async function updateTeam({ item, teamId }) {
  try {
    const data = await updateItemInCollection("teams", teamId, item);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}
